import { translate } from '../common/helpers/translate.helper';
import { LoadingIndicator } from '../common/LoadingIndicator/LoadingIndicator';

import type { AgentFormValues } from './AgentForm/AgentForm';
import { AgentForm } from './AgentForm/AgentForm';
import { useAgentDetails } from './detail/hooks/useAgentDetails.js';
import { useAgentEdit } from './useAgentEdit';

interface UpdateAgentFormProps {
    agentId: string;
    onSuccess?: () => void;
}

export const UpdateAgentForm = ({ agentId, onSuccess }: UpdateAgentFormProps) => {
    const agentQuery = useAgentDetails(agentId);
    const agentEditMutation = useAgentEdit(onSuccess);

    const handleSubmit = async (agent: AgentFormValues) => {
        try {
            await agentEditMutation.mutateAsync({ agent, agentId });
        } catch {
            return;
        }
    };

    if (agentQuery.isPending || !agentQuery.data) {
        return <LoadingIndicator variant="full-height" />;
    }

    return (
        <AgentForm
            primaryActionText={translate('agents.updateAgent')}
            onSubmit={handleSubmit}
            agent={agentQuery.data}
        />
    );
};
